import { craftPillars } from "../data/portfolioData";

function ChapterCraft() {
  return (
    <section id="craft" className="chapter craft-section" data-section="craft" data-testid="chapter-02-craft">
      <div className="chapter-intro">
        <div className="section-kicker"><span>02</span><span>THE SPECTRUM OF CRAFT</span></div>
        <div><h2 data-testid="chapter-02-heading">Many disciplines. One through-line.</h2><p className="chapter-lead">I move comfortably from system diagrams to shipped interfaces to the moment an idea has to make sense in a room.</p></div>
      </div>
      <div className="craft-grid">
        {craftPillars.map((pillar, index) => (
          <article className="craft-card reveal-item" key={pillar.code} data-testid={`craft-pillar-card-${index}`}>
            <div className="card-topline"><span>{pillar.code}</span><span>0{index + 1}</span></div>
            <h3>{pillar.title}</h3>
            <p>{pillar.body}</p>
            <div className="tag-row">{pillar.tags.map((tag) => <span key={tag}>{tag}</span>)}</div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default ChapterCraft;
